import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { route } from "../_app/consts";
import { EntityType } from "../_app/types";

export const useAppNavigate = () => {
  const navigate = useNavigate();

  return useMemo(() => {
    return {
      bots: () => navigate(route.bots),
      onboarding: () => navigate(route.onboarding),
      profile: () => navigate(route.profile),
      back: () => navigate(-1),
      creation: (value: EntityType) => navigate(`/creation/${value}`),
      tickers: (value: EntityType) => navigate(`/choosepair/${value}`),
      createBot: () => navigate(`/choosepair/bot`),
      createStrategy: () => navigate(`/choosepair/strategy`),
      accountAdd: () => navigate(route.account.add),
      accountSettings: (value: string) => navigate(`/account/settings/${value}`),
      notifications: () => navigate(route.notifications),
      lastPath: (lastPath: string) => navigate(lastPath, { replace: true }),
      notificationSettings: () => navigate(`/account/notifications/`),
      botList: (value: "active" | "archived", replace?: boolean) =>
        navigate(`/bots/list/${value}`, { replace: replace }),
      strategyDetail: (type: "active" | "archived", value: string, replace?: boolean) =>
        navigate(`/strategy/list/${type}/${value}`, { replace: replace }),
      strategyList: (value: "active" | "archived", replace?: boolean) =>
        navigate(`/strategy/list/${value}`, { replace: replace }),
    };
  }, [navigate]);
};
